import React from 'react';

const AudienceAgendaComponent = ({
    evento,
    onSelectAgendaEvent
  }) => {

    const showAudience=()=>{
        onSelectAgendaEvent(evento.event.audienciaId);
    }

    return(
        <React.Fragment>
            <div>
                <a href="#" onClick={showAudience}>{evento.title}</a> 
                <em >{evento.description}</em>
            </div>
        </React.Fragment>
    );
}
  
export default AudienceAgendaComponent;